export default {"src":"/_next/static/media/close-account.e4764bdf.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};